import React, { type FC, type PropsWithChildren, memo, use, useEffect } from "react";

import { AppRoutes, type RouterParams } from "@domain/routing/routeConstants";
import { CompanyAccountingYearContext } from "@domain/context/CompanyContext";
import { type ProductKey } from "@domain/models/Product";
import { useIntl } from "react-intl";
import { useLocation, useParams } from "react-router-dom";

interface Props {
    productKey?: ProductKey;
}

const TitledPageImpl: FC<PropsWithChildren<Props>> = (props) => {
    const { pathname } = useLocation();
    const params = useParams<RouterParams>();

    const { yearKbs, yearBanks } = use(CompanyAccountingYearContext);
    const { productKey } = props;

    const intl = useIntl();
    let title = "Binale";

    const productTranslationKey = "app.titles." + productKey;
    if (intl.messages[productTranslationKey]) {
        title = intl.formatMessage({ id: productTranslationKey });
    }

    if (pathname === AppRoutes.SuSa) {
        title = intl.formatMessage({ id: "app.titles.SuSa" });
    }
    if (pathname === AppRoutes.calendar) {
        title = intl.formatMessage({ id: "app.titles.calendar" });
    }
    if (pathname === AppRoutes.accountsView) {
        title = intl.formatMessage({ id: "app.titles.KA" });
    }
    if (pathname === AppRoutes.filtersAndSearchView) {
        title = intl.formatMessage({ id: "app.titles.filtern" });
    }

    if (pathname.startsWith(AppRoutes.bank)) {
        const bank = yearBanks.find((b) => b.id === params.uuid);
        if (bank) {
            title += " " + bank.accountNum;
        }
    }
    if (pathname.startsWith(AppRoutes.kassenbuch)) {
        const kasse = yearKbs.find((k) => k.id === params.uuid);
        if (kasse) {
            title += " " + kasse.accountNum;
        }
    }
    if (pathname.startsWith(AppRoutes.manageAccount)) {
        title = intl.formatMessage({ id: "app.titles.kontenverwaltung" });
    }
    if (pathname.startsWith("/documents")) {
        title += " DMS";
    }

    useEffect(() => {
        document.title = title;
    }, [title]);

    return <>{props.children}</>;
};
export const TitledPage = memo(TitledPageImpl);
